import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useDiscountCardInformationSection} from '../../backend-services/Basket/hooks/useGetBasketPageSection';
import {DiscountCardWithData} from './DiscountCardWithData';

export const DiscountCardWithProducts = ({
  className,
  clientOnlyData,
}: {
  className?: string;
  clientOnlyData?: boolean;
}) => {
  return (
    <DataFetcher
      request={useDiscountCardInformationSection()}
      View={({className, ...props}) => {
        return (
          <DiscountCardWithData
            discountCardThumbnails={props}
            className={className}
            clientOnlyData={props.clientOnlyData}
          />
        );
      }}
      viewProps={{className, clientOnlyData}}
      Error={null}
    />
  );
};
